export default "__VITE_ASSET__b0ddcd6a__"